import styled from 'styled-components';

export const PublicShell = styled.div`
  min-height: ${(props) => (props.$preview ? 'auto' : '100vh')};
  background: ${(props) => (props.$preview ? 'transparent' : props.$bg || '#f5f5f5')};
  font-family: ${(props) => props.$font || 'Inter, sans-serif'};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${(props) => (props.$preview ? '8px 16px 24px' : '32px 16px')};
  color: ${(props) => props.$text || '#262626'};
`;

export const SurveyCard = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  width: 100%;
  max-width: 720px;
  padding: 40px;
`;

export const Logo = styled.img`
  max-height: 80px;
  margin-bottom: 24px;
`;

export const SurveyTitle = styled.h1`
  margin: 0 0 8px;
  font-size: 28px;
  color: ${(props) => props.$color || '#262626'};
`;

export const SurveyDescription = styled.p`
  margin: 0 0 24px;
  color: #595959;
  font-size: 16px;
`;

export const QuestionBlock = styled.div`
  margin-bottom: 28px;

  .question-label {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 6px;
    color: inherit;
  }

  .required {
    color: #E31B23;
    margin-left: 4px;
  }

  .description {
    color: #8c8c8c;
    font-size: 13px;
    margin-bottom: 12px;
  }
`;

export const SubmitBar = styled.div`
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
`;

export const ThankYouCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 60px 40px;
  text-align: center;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);

  h2 {
    margin: 16px 0 8px;
    font-size: 28px;
  }

  img.thank-you-image {
    max-width: 280px;
    margin-top: 24px;
  }
`;
